<template>
  <div class="item-main">
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-empty v-if="isEmpty" description="暂无数据" />
      <!-- 
     v-model:loading="loading"
        @load="onLoad"
        :finished="finished" -->
      <van-list style="height: 100%">
        <div
          class="item-content"
          @click="jumpToApprove(item)"
          v-for="item in approveList"
          :key="item.leaveId"
        >
          <div class="top-title">
            <span>{{ `${item.empName}的请假` }}</span>
            <span>{{ status(item.leaveStatus) }}</span>
          </div>
          <span>请假类型: {{ item?.leaveType === 1 ? "公事" : "私事" }}</span>
          <span>开始时间: {{ moment(item?.startDate, "YYYYMMDDHHmm").format("YYYY年MM月DD日 HH点mm分") }}</span>
          <span>结束时间: {{ moment(item?.endDate, "YYYYMMDDHHmm").format("YYYY年MM月DD日 HH点mm分") }}</span>
        </div>
      </van-list>
    </van-pull-refresh>
  </div>
</template>

<script setup lang="ts">
import { useRouter } from "vue-router";
import { getAuditList } from "@/api/leave";
import moment from "moment";
// 请假类型:1、公事，2:私事
const props = defineProps({
  type: { type: Number, default: 0 }, // type 0 待处理  1 已处理
});

const router = useRouter();

const approveList: any = ref([]);
const isEmpty = ref(false);
const refreshing = ref(false);
// 请假状态,0:审批中,1:已批准,2:已拒绝）
const status = (params) => {
  if (params === 0) {
    return "审批中";
  }
  if (params === 1) {
    return "已批准";
  }
  if (params === 2) {
    return "已拒绝";
  }
  return "";
};
// const loading = ref(false);
// const finished = ref(false);
const onRefresh = () => {
  // finished.value = false;
  // loading.value = true;
  onLoad();
};

const onLoad = () => {
  // 请假状态,0:审批中,1:已批准,2:已拒绝）
  getAuditList({ leaveStatus: props.type })
    .then((res: any) => {
      if (refreshing.value) {
        refreshing.value = false;
      }
      // loading.value = false;
      // finished.value = true;
      if (res && res.length > 0) {
        isEmpty.value = false;
        approveList.value = res;
      } else {
        isEmpty.value = true;
      }
    })
    .catch(() => {
      // finished.value = true;
      // loading.value = false;
      refreshing.value = false;
      if (approveList.value.length === 0) {
        isEmpty.value = true;
      }
    });
};
// 如果是待审批，则跳转到审批页面
const jumpToApprove = (item: any) => {
  // if (props.type === 0) {
  // console.log("push item", item);
  // 待处理
  router.push({
    name: "leaveapprove",
    params: { itemData: JSON.stringify(item) },
  });
  // }
};

onMounted(() => {
  refreshing.value = true;
  onRefresh();
});
</script>

<style scoped>
.item-main {
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: #fff;
}
.item-content {
  display: flex;
  flex-direction: column;
  gap: 10px;
  background-color: #fff;
  border-bottom: 1px solid #ececec;
  padding: 10px;
}
.top-title {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 10px 0px;
}
</style>
